"use strict";

require("@patsnap-ui/icon/assets/solid/DropdownOpen.svg");
require("@patsnap-ui/icon/assets/solid/DropdownRight.svg");
require("@patsnap-ui/icon/assets/solid/DropdownClose.svg");
require("@patsnap-ui/icon/assets/solid/TranslateEnglish.svg");
require("@patsnap-ui/icon/assets/solid/tick.svg");